/**
 * Occupation type
 * DOC: https://schema.org/Occupation
 */

export default ({
  sameAs
}) => ({
  '@type': 'Occupation',
  ...(sameAs && {
    sameAs
  })
});